import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/metamask-logo.png'
import _imports_1 from '@/assets/images/walletconnect-logo.png'
import _imports_2 from '@/assets/images/coinbase-wallet-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-48e7f29f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-payment-method" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pay with ETH", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkout-payment-method-logos" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "MetaMask"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "WalletConnect"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Coinbase Wallet"
  })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import CheckoutItems from '@/components/checkout/CheckoutItems.vue';
import PayWithCardButton from '@/components/checkout/PayWithCardButton.vue';
import NumberToMintInput from '@/components/NumberToMintInput.vue';
import OptimismBanner from '@/components/OptimismBanner.vue';
import { useClaimStore } from '@/store/claimStore';

interface ChoosePaymentMethodPageProps {
  onChoseMethod: (method: string) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChoosePaymentMethodPage',
  props: {
    onChoseMethod: { type: Function }
  },
  setup(__props: any) {



const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NumberToMintInput),
    _createVNode(CheckoutItems, {
      "number-to-mint": _unref(store).tokensToMint,
      cost: _unref(store).cost,
      "has-fees": _unref(store).hasProcessingFees,
      price: _unref(store).price,
      "price-in-usd": _unref(store).priceInUsd,
      "manifold-fee": _unref(store).manifoldFee,
      "manifold-fee-in-usd": _unref(store).manifoldFeeInUsd,
      total: _unref(store).totalCost,
      "total-in-usd": _unref(store).totalCostInUsd,
      "erc-twenty": _unref(store).erc20Address ? _unref(store).erc20Symbol : ''
    }, null, 8, ["number-to-mint", "cost", "has-fees", "price", "price-in-usd", "manifold-fee", "manifold-fee-in-usd", "total", "total-in-usd", "erc-twenty"]),
    _createVNode(OptimismBanner, { class: "checkout-network" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "checkout-payment-method-button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.onChoseMethod('eth')))
      }, _hoisted_4),
      _createVNode(PayWithCardButton, {
        class: "checkout-payment-method-button",
        type: "button",
        onClicked: _cache[1] || (_cache[1] = ($event: any) => (__props.onChoseMethod('card')))
      })
    ])
  ], 64))
}
}

})